import { render, staticRenderFns } from "./Koronarokotepetokset.vue?vue&type=template&id=8f9df526&scoped=true"
import script from "./Koronarokotepetokset.vue?vue&type=script&lang=js"
export * from "./Koronarokotepetokset.vue?vue&type=script&lang=js"
import style0 from "./Koronarokotepetokset.vue?vue&type=style&index=0&id=8f9df526&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f9df526",
  null
  
)

export default component.exports